import dayjs from 'dayjs'
import { INotification } from 'services/notifications/types'

// "20260826060000" (YYYYMMDDHHmmss) -> "26 Aug, 06:00". Falls back to null if it doesn't match
// that shape, since this is a display nicety, not a data guarantee.
export const formatRecurrenceTs = (value: string): string | null => {
  const match = value.match(/^(\d{4})(\d{2})(\d{2})(\d{2})(\d{2})(\d{2})$/)
  if (!match) return null
  const [, year, month, day, hour, minute] = match
  const parsed = dayjs(`${year}-${month}-${day}T${hour}:${minute}:00`)
  return parsed.isValid() ? parsed.format('D MMM, HH:mm') : null
}

// Which occurrence of a recurring task/schedule this notification is about — the one piece of
// `data` that's genuinely meaningful to a person, unlike the raw entity ids around it.
export const getOccurrenceLabel = (notification: INotification): string | null => {
  const raw = notification.data?.recurrence_ts
  return typeof raw === 'string' ? formatRecurrenceTs(raw) : null
}

// The context (a user or a group) this notification is scoped to. Every service names this field
// differently, but where present it's always a resolvable id — worth showing as a name via
// ContextDisplay, unlike opaque entity ids (tid/oid/cid/service_call_id/...) which mean nothing to
// a person and are intentionally not surfaced anywhere in the preview column.
export const getNotificationContextId = (notification: INotification): string | null => {
  const objectRef = notification.object_ref ?? {}
  const data = notification.data ?? {}
  const candidate =
    objectRef.context_id ??
    objectRef.result_context_id ??
    objectRef.group_id ??
    data.context_id ??
    data.group_id ??
    data.task_context_id

  return typeof candidate === 'string' && candidate ? candidate : null
}
